import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ACCOUNT_ID = ':accountId';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.carrier}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/carriers/accounts/${ACCOUNT_ID}`;

export interface DeleteCarrierAccountCommandArgs {
  sellerId: string;
  accountId: string;
}

export const deleteCarrierAccountRequest = ({
  sellerId,
  accountId,
}: DeleteCarrierAccountCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId).replace(
    ACCOUNT_ID,
    accountId,
  ),
  config: { method: SUPPORTED_METHODS.DELETE, json: {} },
});

export async function deleteCarrierAccountCommand(
  payload: DeleteCarrierAccountCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    return await executeQuery<BaseBackResponse>(
      deleteCarrierAccountRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
